import * as _ from "lodash";
import * as Backbone from "backbone";
import {BaseAccountOverviewView} from "../_BaseAccountViews";
import {DashboardChannelCollection} from "../../../collections/DashboardChannels";
import {
    ReportChannelView,
    ReportInstallView,
    ReportTeamView,
    ReportUserView
} from "./ReportDetailViews";

export class ReportOverviewView extends BaseAccountOverviewView {
    private currentReport: Backbone.Model;
    private dashboardChannelCollection: DashboardChannelCollection = null;

    show(reportId, detail?, subDetail?) {
        this.currentDetail = detail;
        this.currentReport = this.options.reportsCollection.findWhere({id: Number(reportId)});
        this.dashboardChannelCollection = new DashboardChannelCollection([], {dashboardId: Number(this.currentReport.get('dashboard_id'))});

        this.collectionLoaded = true;
        this.render();

        // If there is a detail render it exclusively
        if (detail) {
            this.renderSubViews(detail, false);
            return;
        }

        // Otherwise render all details
        _.each(['teams', 'users', 'installs', 'channels', 'notifications'], (viewClass) => {
            this.renderSubViews(viewClass, true);
        });
    }

    render() {
        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            title: this.currentReport ? this.currentReport.get('name') : '',
            canView: true
        }));

        this.showBreadcrumbs();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
        return this;
    }

    showBreadcrumbs() {
        if (!this.options.currentOrganizationId || !this.currentReport) return;
        var orgId = this.options.currentOrganizationId;
        var reportId = this.currentReport.get('id');

        var routeString = '/#/account/' + orgId + '/reports/' + reportId;
        this.breadcrumbPathMap = {
            [this.currentOrganization.get('name')]: '/#/account/' + orgId,
            'Reports': '/#/account/' + orgId + '/reports'
        };

        var currentPath, searchByX;
        if (this.currentDetail) {
            this.breadcrumbPathMap[this.currentReport.get('name')] = routeString;

            searchByX = 'Report Details';
            this.breadcrumbDropDownOptions = {
                'Users': routeString + '/users',
                'Teams': routeString + '/teams',
                'Installs': routeString + '/installs',
                'Channels': routeString + '/channels',
            };
            currentPath = _.capitalize(this.currentDetail);
        } else {
            searchByX = 'Report';
            currentPath = this.currentReport.get('name');
            this.options.reportsCollection.each((r) => {
                this.breadcrumbDropDownOptions[r.get('name')] = '/#/account/' + orgId + '/reports/' + r.get('id');
            });
        }

        super.showBreadcrumbs(currentPath, searchByX);
    }

    renderSubViews(detail, isOverview) {
        var options = {
            currentReport: this.currentReport,
            groupPermissionCollections: this.groupPermissionCollections,
            dashboardChannelCollection: this.dashboardChannelCollection,
            isOverview: isOverview
        };

        var subview;
        switch (detail) {
            case 'teams':
                subview = new ReportTeamView(_.extend({}, this.options, options));
                break;
            case 'users':
                subview = new ReportUserView(_.extend({}, this.options, options));
                break;
            case 'installs':
                subview = new ReportInstallView(_.extend({}, this.options, options));
                break;
            case 'channels':
                subview = new ReportChannelView(_.extend({}, this.options, options));
                break;
        }

        if (subview) {
            this.subViews.push(subview);
            this.$('.container').append(subview.render().$el);
            subview.show();
        }
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/reports/ReportOverviewView.ts